var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 12,
    viewBox: "0 0 18 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Eye_View",
    "data-name": "Eye View",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ic_remove_red_eye_24px",
    d: "M10,4.5a9.675,9.675,0,0,0-9,6,9.675,9.675,0,0,0,9,6,9.675,9.675,0,0,0,9-6A9.675,9.675,0,0,0,10,4.5Zm0,10a4,4,0,1,1,4.091-4A4.048,4.048,0,0,1,10,14.5Zm0-6.4a2.4,2.4,0,1,0,2.455,2.4A2.424,2.424,0,0,0,10,8.1Z",
    transform: "translate(-1 -4.5)",
    fill: "#09819a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOpen);
export default __webpack_public_path__ + "static/media/eye-open.bdb9a377e76e149a59399e5b4ed3bfe1.svg";
export { ForwardRef as ReactComponent };